<template>
  <b-modal
    id="modal-regularization-filters"
    ref="modal-regularization-filters"
    :visible="visible"
    title="Filter Leaves &amp; Regularization"
    @ok="onOk"
    @hidden="$emit('update:visible', false)"
    size="md"
    ok-title="Apply"
    cancel-title="Cancel"
  >
    <b-form>
      <b-form-group
        v-if="viewMode === 'team' || viewMode === 'org'"
        label="Employee"
        label-for="reg-employee-filter"
      >
        <b-form-select
          id="reg-employee-filter"
          :value="regularizationEmployeeFilterTemp"
          :options="regularizationFilterEmployeeOptions"
          size="sm"
          @change="$emit('update:regularizationEmployeeFilterTemp', $event)"
        />
      </b-form-group>
      <b-form-row>
        <b-col cols="6">
          <b-form-group label="From Date" label-for="reg-from-date-filter">
            <b-form-input
              id="reg-from-date-filter"
              :value="regularizationFromDateFilterTemp"
              type="date"
              size="sm"
              @input="$emit('update:regularizationFromDateFilterTemp', $event)"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="To Date" label-for="reg-to-date-filter">
            <b-form-input
              id="reg-to-date-filter"
              :value="regularizationToDateFilterTemp"
              type="date"
              size="sm"
              @input="$emit('update:regularizationToDateFilterTemp', $event)"
            />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-group label="Leave Type" label-for="reg-leave-type-filter">
        <b-form-select
          id="reg-leave-type-filter"
          :value="regularizationLeaveTypeFilterTemp"
          :options="leaveTypeFilterOptions"
          size="sm"
          @change="$emit('update:regularizationLeaveTypeFilterTemp', $event)"
        >
          <template #first>
            <option :value="null">All Leave Types</option>
          </template>
        </b-form-select>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormRow, BCol, BFormSelect, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'RegularizationFiltersModal',
  components: {
    BModal, BForm, BFormGroup, BFormRow, BCol, BFormSelect, BFormInput,
  },
  methods: {
    onOk(bvModalEvt) {
      this.$emit('ok', bvModalEvt)
    },
  },
  props: {
    visible: { type: Boolean, default: false },
    viewMode: { type: String, default: 'my' },
    regularizationEmployeeFilterTemp: { type: String, default: null },
    regularizationFilterEmployeeOptions: { type: Array, default: () => [] },
    regularizationFromDateFilterTemp: { type: String, default: null },
    regularizationToDateFilterTemp: { type: String, default: null },
    regularizationLeaveTypeFilterTemp: { type: String, default: null },
    leaveTypeFilterOptions: { type: Array, default: () => [] },
  },
}
</script>
